import { useState, useEffect } from 'react';
import { UseCheckoutPricingState } from '@recurly/react-recurly';

interface UseCouponCodeProps {
  initialCouponCode?: string;
}

const emptyCheckoutPrice = {
  now: {
    items: [],
    subscriptions: '',
    adjustments: '',
    discount: '',
    subtotal: '',
    taxes: '',
    giftCard: '',
    total: '',
  },
  next: {
    items: [],
    subscriptions: '',
    adjustments: '',
    discount: '',
    subtotal: '',
    taxes: '',
    giftCard: '',
    total: '',
  },
  currency: {
    code: '',
    symbol: '',
  },
  taxes: [],
};

type PriceInterface = UseCheckoutPricingState['price'];

const useCouponCode = ({ initialCouponCode }: UseCouponCodeProps) => {
  const [coupon, setCoupon] = useState('');
  const [price, setPrice] = useState<PriceInterface>(emptyCheckoutPrice);

  useEffect(() => {
    if (initialCouponCode) {
      setCoupon(initialCouponCode);
    }
  }, [initialCouponCode]);

  const handleReturnPrice = (recurlyPrice: PriceInterface) => {
    setPrice(recurlyPrice);
  };

  const handleOnChange = (value: string) => {
    setCoupon(value);
  };

  const resetInput = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setCoupon('');
    setPrice(emptyCheckoutPrice);
  };

  return {
    coupon,
    price,
    initialCouponCode,
    handleReturnPrice,
    handleOnChange,
    resetInput,
  };
};

type UseCouponCodeInterface = ReturnType<typeof useCouponCode>;

export default useCouponCode;
export type { UseCouponCodeInterface, PriceInterface };
